import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'pme-development',
    templateUrl: './development.component.html',
    standalone: false
})

export class DevelopmentComponent implements OnInit {

  constructor() {
  }

  submitting: boolean;

  ngOnInit() {
  }

}
